import { render, staticRenderFns } from "./LegacyImportationList.vue?vue&type=template&id=d753cff6"
import script from "./LegacyImportationList.vue?vue&type=script&lang=js"
export * from "./LegacyImportationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports